import React, { useState, useRef, SetStateAction, useEffect } from "react";
import CustomInput from "../../../Component/BasicComponents/CustomInput";
import { Btn } from "../../../AbstractElements";
import {
  useAddAgenda,
  useGetAgendaControlType,
  useGetAgendaSurveys,
  useGetAttendeesSurveys,
  useUpdateAgenda,
} from "./UseAgenda";

import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { useGetOrgUnitsData } from "../../FSM/Beats_Patches/hooks/useBeat";
import { useGetStatusOptionsData } from "../../FSM/Subscriber/hooks/useSubscriber";
import { handleMedia } from "../../edetailing/repository/EdetailingRepository";
import { FaTrash } from "react-icons/fa";

interface CommonFormProp {
  onPressForCancilModal?: () => void;
  setIsModal: React.Dispatch<SetStateAction<boolean>>;
  mode?: string;
  rowData?: any;
}

interface formData {
  Name: string;
  IsPrivate: boolean;
  Agendacontroltype: string;
  Orgunitid: number | string;
  Status: string;
  Agendaimage: any;
  SurveryIdForQuestions?: number | undefined;
  HasAttendees?: boolean;
  SurveryIdForAttendeesQuestions?: number | undefined;
}

const CommonForm: React.FC<CommonFormProp> = ({onPressForCancilModal,setIsModal,rowData,mode,}) => {

  useEffect(() => {
    if (mode === "edit" && rowData) {
      setFormData((prev: any) => ({
        ...prev,
        Name: rowData.AgendaName,
        Agendacontroltype: rowData.AgendaControlType,
        Orgunitid: rowData.OrgUnitId,
        Status: rowData.Status,
        IsPrivate: rowData.IsPrivate,
        Agendaimage: rowData.Agendaimage,
        HasAttendees:rowData.HasAttendees,
        SurveryIdForQuestions:rowData.SurveryIdForQuestions,
        SurveryIdForAttendeesQuestions:rowData.SurveryIdForAttendeesQuestions,

      }));
    }
  }, [mode]);
  
  const BASE_URL = "https://tspc-development.truesales.in/media?id=";
  const { data, isLoading, isSuccess } = useGetAgendaControlType({
    enabled: true,
  });
  const { data: orgUnitsData,isLoading: orgDataLoading,isSuccess: orgDataSuccess,} = useGetOrgUnitsData({ enable: true });
  const{data:AgendaSurveysDataFor_dropDown,isLoading:AgendaSurveysDataFor_dropDown_IsLoading,isSuccess:AgendaSurveysDataFor_dropDown_isSuccess} = useGetAgendaSurveys({enable:true});
  const{data:AttendeesSurveysData,isLoading:AttendeesSurveys_IsLoading,isSuccess:AttendeesSurveys_IsSuccess} =useGetAttendeesSurveys({enable:true});

  const { data: statusOptions } = useGetStatusOptionsData({ enable: true });
  const { mutate: addAgenda } = useAddAgenda();
  const { mutate: UpdateAgneda } = useUpdateAgenda();

  const [formData, setFormData] = useState<formData>({
    Name: "",
    IsPrivate: false,
    Agendacontroltype: "",
    Orgunitid: "",
    Status: "",
    Agendaimage: "",
    SurveryIdForQuestions:undefined,
    HasAttendees: false,
    SurveryIdForAttendeesQuestions: undefined,
  });

  const handleInput = (fieldName: keyof formData, value: any) => {
    setFormData((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const handleCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      IsPrivate: e.target.checked,
    });
  };

  const handleCheckHasAttendees = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      HasAttendees: e.target.checked,
    });
  };


  const handleFormSubmit = () => {
    if (formData.IsPrivate === true && formData.Status === "1") {
      if (mode !== "edit") {
        const ReqBody = {
          Agendacontroltype: formData.Agendacontroltype,
          Agendname: formData.Name,
          Status: formData.Status,
          Orgunitid: Number(formData.Orgunitid),
          Agendaimage: formData.Agendaimage,
          IsPrivate: formData.IsPrivate,
          HasAttendees: formData.HasAttendees,
          SurveryIdForQuestions: Number(formData.SurveryIdForQuestions),
          SurveryIdForAttendeesQuestions:Number(formData.SurveryIdForAttendeesQuestions),
        };
        console.log('Add_agenda',ReqBody);

        addAgenda(ReqBody);
      }

      if (mode === "edit") {
        const ReqBody = {
          Agendatypeid: rowData.Agendaid,
          Agendacontroltype: formData.Agendacontroltype,
          Agendname: formData.Name,
          Orgunitid: Number(formData.Orgunitid),
          Status: formData.Status,
          IsPrivate: formData.IsPrivate,
          Agendaimage: formData.Agendaimage,
          SurveryIdForQuestions:Number(formData.SurveryIdForQuestions),
          HasAttendees:formData.HasAttendees,
          SurveryIdForAttendeesQuestions: formData.SurveryIdForAttendeesQuestions,
        };
        console.log('ReqBody====>',ReqBody)
        UpdateAgneda(ReqBody);
      }

      // modal close
      setIsModal(false);
    }
  };

  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];

    if (file) {
      try {
        const mediaID = await handleMedia(file);
        setFormData((prev: any) => ({
          ...prev,
          Agendaimage: mediaID,
        }));
      } catch (error: any) {
        console.log("Media upload Failed: ", error);
      }
    }
  };

  // console.log('AgendaSurveysDataFor_dropDown',AgendaSurveysDataFor_dropDown);


  return (
    <form>
      
      {/* <div className="row mb-0">

        <div className="col-md-12" style={{display:'flex',flexDirection:'row',gap:'8px'}}>

          <div className="col-md-6">       
            <CustomInput
            required
            label="Name *"
            type="text"
            style={{ borderColor: "#d6d6d6" }}
            value={formData.Name}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleInput("Name", e.target.value)
            }
          />
          </div>

          <div className="col-md-6">
          <ReusableDropdown
            DropdownHeading="Agenda Control Type"
            value={formData.Agendacontroltype}
            onChange={(opt) => handleInput("Agendacontroltype", opt)}
            options={(!isLoading && isSuccess && data?.data) || []}
          />
        </div>

        </div>


        <div className="col-md-12" style={{display:'flex',flexDirection:'row',gap:'8px'}}>
          <div className="col-md-6">
          <ReusableDropdown
            DropdownHeading="Agenda Control Type"
            value={formData.Agendacontroltype}
            onChange={(opt) => handleInput("Agendacontroltype", opt)}
            options={(!isLoading && isSuccess && data?.data) || []}
          />
          </div>
        <div className="col-md-6">
          <ReusableDropdown
            DropdownHeading="Org Unit"
            options={
              (!orgDataLoading && orgDataSuccess && orgUnitsData?.data) || []
            }
            onChange={(opt) => handleInput("Orgunitid", opt)}
            value={formData.Orgunitid}
          />
        </div>
        </div>



        <div className="col-md-12" style={{display:'flex',flexDirection:'row',gap:'8px'}}>
         <div className="col-md-6"> 
          <ReusableDropdown
            DropdownHeading="Status"
            value={formData.Status}
            options={statusOptions?.data || []}
            onChange={(opt) => handleInput("Status", opt)}
          />
          </div>
          <div className="col-md-6">
          <ReusableDropdown
            DropdownHeading="Survery Id For Questions Survery Id For Questions"
            // value={formData.Status}
            options={[]}
            onChange={(opt) => handleInput("Status", opt)}
          />
        </div>
        </div>  


        <div className="col-md-12">
          <div className=" row mb-0 mt-4">
            <div className="col-md-4 mt-4">
              <label>Is Private</label>
              <input
                required
                style={{ margin: 10 }}
                type="checkbox"
                checked={formData.IsPrivate}
                onChange={handleCheck}
              />
            </div>

            <div className="col-md-8">
             <div style={{ textAlign: "center"  }}>
              <label>Upload Media</label>
              <input
                className="form-control"
                type="file"
                accept="image/*"
                style={{
                  // marginLeft:'24px',
                   display: "block",
                   marginLeft: "auto",
                  border: "1px solid #e0e0e0",
                  borderRadius: "8px",
                  padding: "13px",
                  fontSize: "14px",
                  width: "80%",
                  color: "red",
                }}
                onChange={(e) => handleFileChange(e)}
              />
             </div>
            </div>

            <div
              className="row mb-3"
              style={{ justifyContent: "flex-end", marginTop: "4px" }}
            >
              <div className="col-md-6">
                {formData.Agendaimage && (
                  <img
                    // src={
                    //   formData.Agendaimage != null &&( `${BASE_URL}${formData.Agendaimage}`)
                    //     ? `${BASE_URL}${formData.Agendaimage}`
                    //     : "https://via.placeholder.com/100?text=No+Image"
                    // }
                    src={`${BASE_URL}${formData.Agendaimage}`}
                    // alt={formData.Agendaimage ? "Uploaded " : "Dummy Image"}
                    style={{
                      width: "80px",
                      height: "80px",
                      borderRadius: "8px",
                    }}
                  />
                )}
              </div>
            </div>

          </div>
        </div>


        <div className="col-md-12">
            <label>Has Attendees</label>
            <input
              required
              style={{ margin: 10 }}
              type="checkbox"
              checked={formData.HasAttendees}
              onChange={handleCheckHasAttendees}
            />
        </div>

        {formData.HasAttendees &&( 
        <div className="col-md-12">
          <ReusableDropdown
            DropdownHeading="Survery Id For Attendees Questions"
            // value={formData.Status}
            options={[]}
            onChange={(val)=>alert(JSON.stringify(val))}
          />
          </div>  
        )
        }


        <div className="d-flex justify-content-start gap-2 mt-3">
          <Btn
            style={{ backgroundColor: "#43B9B2", color: "white" }}
            onClick={handleFormSubmit}
          >
            Submit
          </Btn>
          <Btn
            type="button"
            onClick={onPressForCancilModal}
            style={{ backgroundColor: "#F9FAFC", color: "#000" }}
          >
            {" "}
            Cancel
          </Btn>
        </div>
      </div> */}

<div className="row mb-0">

  {/* First Row */}
  <div className="row mb-0">
    <div className="col-md-12">
      <CustomInput
         
        required
        asterisk
        label="Name"
        type="text"
        style={{ borderColor: "#d6d6d6", borderRadius:'4px'}}
        value={formData.Name}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          handleInput("Name", e.target.value)
        }
      />
    </div>
    {/* <div className="col-md-6">
      <ReusableDropdown
        DropdownHeading="Agenda Control Type"
        value={formData.Agendacontroltype}
        onChange={(opt) => handleInput("Agendacontroltype", opt)}
        options={(!isLoading && isSuccess && data?.data) || []}
      />
    </div> */}
  </div>

  {/* Second Row */}
  {/* <div className="col-md-12 d-flex gap-3"> */}
  <div className="row mb-1">
    <div className="col-6">
      <ReusableDropdown
        DropdownHeading="Agenda Control Type" 
        value={formData.Agendacontroltype}
        onChange={(opt) => handleInput("Agendacontroltype", opt)}
        options={(!isLoading && isSuccess && data?.data) || []}
      />
    </div>
    <div className="col-6">
      <ReusableDropdown
        DropdownHeading="Org Unit"
        options={(!orgDataLoading && orgDataSuccess && orgUnitsData?.data) || [] }
        value={formData.Orgunitid}
        onChange={(opt) => handleInput("Orgunitid", opt)}
      />
    </div>
  </div>


  {/* Third Row */}
  <div className="row mb-1">
    <div className="col-6">
      <ReusableDropdown
        DropdownHeading="Status"
        value={formData.Status}
        options={statusOptions?.data || []}
        onChange={(opt) => handleInput("Status", opt)}
      />
    </div>
    <div className="col-6">
      <ReusableDropdown
        value={formData.SurveryIdForQuestions}
        DropdownHeading="Survery Id For Questions"
        options={(!AgendaSurveysDataFor_dropDown_IsLoading && AgendaSurveysDataFor_dropDown_isSuccess &&  AgendaSurveysDataFor_dropDown?.formateData) || []}
        onChange={(val)=>handleInput('SurveryIdForQuestions',val)}
      />
    </div>
  </div>

  {/* File Upload + Checkbox */}
  <div className="col-md-12 mt-4">
<div
  className="row align-items-center"
  style={{
    justifyContent: "space-between",
    marginTop: "10px",
    padding: "10px 0",
  }}
>
  {/* ✅ Is Private Section */}
  <div className="col-md-4 d-flex align-items-center"style={{ gap: "10px" }}>
    <label style={{ marginBottom: "0", whiteSpace: "nowrap" }}>
      Is Private
    </label>
    <input
      required
      type="checkbox"
      checked={formData.IsPrivate}
      onChange={handleCheck}
      style={{ transform: "scale(1.2)", cursor: "pointer" }}
    />
  </div>

  {/* ✅ Upload Media Section */}
  <div
    className="col-md-8"
    style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      gap: "8px",
      width:'250px'
    }}
  >
    <label style={{ fontWeight: "500" }}>Upload Media</label>
    <input
      id="mediaUpload"
      className="form-control"
      type="file"
      accept="image/*"
      style={{
        display: "block",
        border: "1px solid #e0e0e0",
        borderRadius: "8px",
        padding: "8px",
        fontSize: "14px",
        width: "220px",
        cursor: "pointer",
      }}
      onChange={(e) => handleFileChange(e)}
    />

    {formData.Agendaimage && (
      <div
        style={{
          position: "relative",
          width: "fit-content",
        }}
      >
        <img
          src={`${BASE_URL}${formData.Agendaimage}`}
          style={{
            width: "55px",
            height: "55px",
            borderRadius: "8px",
            marginTop: "4px",
            border: "1px solid #ccc",
            objectFit: "cover",
          }}
        />
        <span
          onClick={() => {
            setFormData((prevState: any) => ({
              ...prevState,
              file: "",
              Agendaimage: null,
            }));
            const fileInput = document.getElementById(
              "mediaUpload"
            ) as HTMLInputElement;
            if (fileInput) fileInput.value = "";
          }}
          style={{
            position: "absolute",
            top: "-6px",
            right: "-6px",
            background: "#fff",
            border: "1px solid #ccc",
            borderRadius: "50%",
            padding: "2px 4px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          }}
        >
          <FaTrash size={10} color="red" />
        </span>
      </div>
    )}
  </div>
</div>


  </div>

  {/* Has Attendees */}
  <div className="col-md-12">
    <label>Has Attendees</label>
    <input
      required
      style={{ marginLeft: "10px" }}
      type="checkbox"
      checked={formData.HasAttendees}
      onChange={handleCheckHasAttendees}
    />
  </div>

  {formData.HasAttendees && (
    <div className="row mb-0 mt-2">
      <ReusableDropdown
        value={formData.SurveryIdForAttendeesQuestions}
        DropdownHeading="Survery Id For Attendees Questions"
        options={(!AttendeesSurveys_IsLoading && AttendeesSurveys_IsSuccess && AttendeesSurveysData?.formateData) || []}
        onChange={(val) =>handleInput('SurveryIdForAttendeesQuestions',val)}
      />
    </div>
  )}

  {/* Buttons */}
  <div className="d-flex justify-content-start gap-2 mt-4">
    <Btn
      style={{ backgroundColor: "#43B9B2", color: "white" }}
      onClick={handleFormSubmit}
    >
      Submit
    </Btn>
    <Btn
      type="button"
      onClick={onPressForCancilModal}
      style={{ backgroundColor: "#F9FAFC", color: "#000" }}
    >
      Cancel
    </Btn>
  </div>
</div>


    </form>
  );
};
export default CommonForm;
